import { Component, OnDestroy, OnInit } from '@angular/core';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { PortalModulesService } from '../../../core/services/portal-modules.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../services/event.service';
import { SmService } from '../../../pages/sm/services/sm.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { SmSharedService } from '../../../pages/sm/services/sm-shared.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../core/services/utility.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { HostListener } from "@angular/core";

import { ConfirmationModalComponent } from 'src/app/modals/sm/confirmation-modal/confirmation-modal.component';
import { ClockOutModalComponent } from 'src/app/modals/sm/clock-out-modal/clock-out-modal.component';
import { ClockInModalComponent } from 'src/app/modals/sm/clock-in-modal/clock-in-modal.component';

@Component({
  selector: 'app-sm-nav',
  templateUrl: './sm-nav.component.html',
  styleUrls: ['./sm-nav.component.css']
})
export class SmNavComponent implements OnInit, OnDestroy {
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  notTech: boolean;
  logoUrl: string;
  showSMManagerDash: boolean = false;
  showWODash: boolean = false;
  enablePWA: boolean;
  isServiceManager: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private ngbModalService: NgbModal,
    private router: Router,
    public HttpClient: HttpClient,
    private eventService: EventService,
    private utilityService: UtilityService,
    private smService: SmService,
    public smDataService: SmDataService,
    private smSharedService: SmSharedService,
    private portalModulesService: PortalModulesService)
  {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }

  ngOnInit(): void {
    this.enablePWA = true;

    this.formData = {};
    this.formData.enableOfflineAccess = this.employeeInfo.EnableOfflineFS;
    this.smDataService.currentOnline = navigator.onLine;
    this.logoUrl = "/Company/GetLogo?co=" + this.employeeInfo.PRCo + "&size=S";

    this.subscriptions.push(this.eventService.on('modulesChanged', () => this.getModules()));

    if (sessionStorage.getItem("SMWODashToManID") != null || sessionStorage.getItem("SMWODashToManIDWithTrip") != null) {
      this.smDataService.isFromSMWODashNow = true;
    }
    if ((window.location.protocol == "http:" && window.location.hostname != "localhost"))
      this.enablePWA = false;

    this.subscriptions.push(this.eventService.on('turnoffOffline', () => this.turnoffOffline()));
    this.subscriptions.push(this.eventService.on('triggerOfflinePost', () => this.triggerOfflinePost()));
    this.subscriptions.push(this.eventService.on("notTech", eventData => this.notTech = eventData.data));
    this.subscriptions.push(this.eventService.on("navClockStatus", eventData => this.navClockStatus(eventData)));
    this.isServiceManager = window.location.pathname == "/sm/workorderdashboard";
    this.getModules();
  }

  private navClockStatus(eventData) {
    setTimeout(() => {
        this.smDataService.clockEmpty = false;
        this.smDataService.clockInStatus = null;

        if (eventData.data == null)
          this.smDataService.clockEmpty = true;
        else
          this.smDataService.clockInStatus = eventData.data;
      });
  }

  public getModules() {
    this.showSMManagerDash = false;
    this.showWODash = false;

    this.portalModulesService.getPortalModules().forEach(val => {
      if (val.ModuleID == 116) {
        this.showSMManagerDash = true;
      }
      if (val.ModuleID == 110) {
        this.showWODash = true;
      }
    });
  };

  public openGlobalNav() {
      document.getElementById("globalSideNav").style.width = "100%";
  };

  public closeGlobalNav(route) {
    document.getElementById("globalSideNav").style.width = "0";
    this.removeSession();
    if (route == "manage") {
      this.smDataService.isFromSMWODashNow = false;
      this.smDataService.isFromSMWODashNowWithTrip = false;
      this.smDataService.isClockOut = false;
      this.smDataService.isCloseOut = false;
      this.smDataService.isDrillDown = false;
      this.smSharedService.resetPage(true, false, true);
      this.smSharedService.removeSession();
      this.isServiceManager = false;
    } else if (route == "service") {
      this.isServiceManager = true;
    }
  };

  public removeSession() {
    this.smSharedService.removeSession();
  }

  public clockAction() {
    if (this.smDataService.clockInStatus != null && this.smDataService.clockInStatus.ClockAction) {
      let modalRef = this.ngbModalService.open(ClockOutModalComponent, { size: 'md', backdrop: 'static' });
      modalRef.componentInstance.woData = null;
      modalRef.componentInstance.clockStatus = this.smDataService.clockInStatus;
      modalRef.componentInstance.isTripExist = true;

      modalRef.result.then((response) => {
        this.smSharedService.resetPage(false, true, true);
        this.smDataService.currentWorkOrder = null;
        this.smDataService.isClockOut = true;
      });
    }
    else {
      let modalRef = this.ngbModalService.open(ClockInModalComponent, { size: 'md', backdrop: 'static' });

      modalRef.result.then((response) => {
        this.eventService.broadcast("smClockInAction");
        this.smDataService.isClockOut = false;
      });
    }
  }

  public triggerOfflinePost() {
    let modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.body = this.smDataService.offlinePostCallList.length + " items need to be synced to the portal.";
    modalRef.componentInstance.header = "Sync Data to Portal";
    modalRef.result.then((response) => {
      if (response) {
        let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb.onsuccess = () => {
          let db = indexdb.result;
          let transaction = db.transaction("SM_OfflineSyncFail", "readwrite");
          let storage = transaction.objectStore("SM_OfflineSyncFail");
          $.each(this.smDataService.offlinePostFailList, function (key, val) {
            storage.clear();
          });
          this.smDataService.haveOfflinePostFail = false;
        }
        indexdb.onerror = () => {
          this.utilityService.closeModal();
        }
        this.startOfflinePost(0);
      } else {
        let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb.onsuccess = () => {
          let db = indexdb.result;
          let transaction = db.transaction("SM_PostCalls", "readwrite");
          let storage = transaction.objectStore("SM_PostCalls");
          let offlinePostCallList = storage.getAll();
          offlinePostCallList.onsuccess = () => {
            setTimeout(() => {
              this.smDataService.offlinePostCallList = offlinePostCallList.result;
              if (offlinePostCallList.result.length > 0) {
                this.smDataService.haveOfflinePost = true;
              }
              else {
                this.smDataService.haveOfflinePost = false;
              }
              this.checkofflinePost();
              this.utilityService.closeModal();
            });
          }
          offlinePostCallList.onerror = () => {
            this.utilityService.closeModal();
          }
        }
        indexdb.onerror = () => {
          this.utilityService.closeModal();
        }
      }
    });
  }

  public startOfflinePost(index) {
    if (index >= this.smDataService.offlinePostCallList.length) {
      this.utilityService.openModal();
      this.smDataService.modalMsg = "Offline Syncing...";
      let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
      indexdb.onsuccess = () => {
        let db = indexdb.result;
        let transaction = db.transaction("SM_PostCalls", "readwrite");
        let storage = transaction.objectStore("SM_PostCalls");
        this.smDataService.offlinePostCallList.forEach((val, key) => {
          if (val.success) {
            storage.delete(val.id);
            if (val.url.toLowerCase().indexOf("insertupdatesmworkcompleted") > -1) {
              let indexdb2 = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
              indexdb2.onsuccess = function () {
                let db2 = indexdb2.result;
                let transaction2 = db2.transaction("SM_GetWorkCompleted", "readwrite");
                let storage2 = transaction2.objectStore("SM_GetWorkCompleted");
                let SM_GetWorkCompletedList = storage2.getAll();
                SM_GetWorkCompletedList.onsuccess = function () {
                  if (SM_GetWorkCompletedList.result.length > 0) {
                    $.each(SM_GetWorkCompletedList.result, function (key2, val2) {
                      if (val.payload.sMWorkCompletedID == val2.SMWorkCompletedID)
                        storage2.delete(val.payload.sMWorkCompletedID);
                    })
                  }
                }
              }
            }
          } else {
            let indexdb2 = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
            indexdb2.onsuccess = () => {
              let db2 = indexdb2.result;
              let transaction2 = db2.transaction("SM_OfflineSyncFail", "readwrite");
              let storage2 = transaction2.objectStore("SM_OfflineSyncFail");

              storage2.put({ url: val.url, payload: val.payload, insertDate: new Date(), result: val.result, deleteID: val.id });
              this.smDataService.haveOfflinePostFail = true;
            }
          }
        });
        this.smDataService.offlinePostCallList = null;
        this.smDataService.haveOfflinePost = false;
        location.reload();
        return false;
      }
    }

    if (index < this.smDataService.offlinePostCallList.length) {
      this.smService.offlinePost(this.smDataService.offlinePostCallList[index].url, this.smDataService.offlinePostCallList[index].payload).then((response: any) => {
        this.smDataService.offlinePostCallList[index].success = response.success;
        if (!response.success) {
          this.smDataService.offlinePostCallList[index].result = response;
        }
        index++;
        this.startOfflinePost(index)
      })
    }
  }

  public clearDB() {
    let modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.body = "Are you sure you want to clear the local database?";
    modalRef.componentInstance.header = "Clear Local Database";

    modalRef.result.then((response) => {
      if (response != null) {
        this.eventService.broadcast("smClearDatabase");
        let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb.onsuccess = () => {
          let db = indexdb.result;
          $.each(this.smDataService.allDBTable, function (key, val) {
            let transaction = db.transaction(val, "readwrite");
            let storage = transaction.objectStore(val);
            storage.clear();
          })
          this.utilityService.closeModal();
        }
        $.each(this.smDataService.tripList, function (key, val) {
          val.ReadyOffline = false;
        })
      }
    });
  }

  private checkofflinePost() {
    if (!this.smDataService.haveOfflinePost) {
      this.smDataService.navbarHeight = 0;
    }
  }

  public saveURL(){
    this.utilityService.openModal();
    sessionStorage.setItem("previousSM", "true");
    window.location.href = "/timecard/index";
    this.closeGlobalNav(null);
    //this.router.navigate(['/timecard/index'])
  }

  public routeToHome() {
    this.utilityService.openModal();
    this.smDataService.tripList = null;
    this.smDataService.tripListFiltered = null;
    this.smSharedService.removeSession();
    this.smSharedService.resetPage(false, false, false);
    this.router.navigate(['/home/index'])
  }

  public turnoffOffline() {
    this.formData.enableOfflineAccess = false;
    this.userSettingUpdate(true);
  }

  public userSettingUpdate(reload) {
    setTimeout(() => {
      this.smService.updateSettings(this.formData.enableOfflineAccess).then((response: any) => {
        if(response.success)
          this.employeeInfo.EnableOfflineFS = this.formData.enableOfflineAccess;
        if (reload) {
          window.location.reload();
        }
      });
    });
  }

  public logout() {
    sessionStorage.clear();
    this.utilityService.isLoggedOut = true;
    window.location.href = '/account/logout?serviceWorker=true';
  }

  @HostListener('window:load', ['$event'])
  onLoad(e: KeyboardEvent) {
    this.smDataService.currentOnline = navigator.onLine;
  }

  @HostListener('window:offline', ['$event'])
  onOffline(e: KeyboardEvent) {
    this.smDataService.currentOnline = false;
  }

  @HostListener('window:online', ['$event'])
  onOnline(e: KeyboardEvent) {
    this.smDataService.currentOnline = true;
    setTimeout(() => {
      if (this.smDataService.enablePWA) {
        this.smDataService.currentOnline = true;
        let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb.onsuccess = () => {
          let db = indexdb.result;
          let transaction = db.transaction("SM_PostCalls", "readwrite");
          let storage = transaction.objectStore("SM_PostCalls");
          let offlinePostCallList = storage.getAll();
          offlinePostCallList.onsuccess = () => {
            setTimeout(() => {
              this.smDataService.offlinePostCallList = offlinePostCallList.result;
              if (offlinePostCallList.result.length > 0) {
                this.smDataService.haveOfflinePost = true;
              }
              else {
                this.smDataService.haveOfflinePost = false;
              }
            });
            setTimeout(() => {
              this.smDataService.navbarHeight = this.smDataService.haveOfflinePost ? (document.getElementById("NavBar").offsetHeight - 60) : 0;
            }, 1000)
          }
        }

        let indexdb2 = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb2.onsuccess = () => {
          let db = indexdb2.result;
          let transaction = db.transaction("SM_OfflineSyncFail", "readwrite");
          let storage = transaction.objectStore("SM_OfflineSyncFail");
          let offlinePostFailList = storage.getAll();
          offlinePostFailList.onsuccess = () => {
            setTimeout(() => {
              this.smDataService.offlinePostFailList = offlinePostFailList.result;
              this.smDataService.haveOfflinePostFail = (this.smDataService.offlinePostFailList.length > 0 ? true : false);
            });
          }
        }
      }
    })
  }
}